var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('div',{staticClass:"app__wrapper"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"content__wrapper"},[_c('Nuxt')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }